import { render } from "./AddForeignDocument.vue?vue&type=template&id=040f8bec"
import script from "./AddForeignDocument.vue?vue&type=script&lang=js"
export * from "./AddForeignDocument.vue?vue&type=script&lang=js"

import "./AddForeignDocument.vue?vue&type=style&index=0&id=040f8bec&lang=css"

import exportComponent from "/builds/boikovky/medsafe-stat-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__